<template>
<b-container
  class="d-flex section"
  style="background-color: #08034c;"
  fluid
  >
  <b-row class="m-auto text-center justify-content-center">
    <b-col class="p-0">
      
<b-container class="text-light text-center" fluid ref="obscure">
  <b-row>
    <b-col>
      <slot name="icon">
	<b-img :src="require('../assets/trinity.png')" class="pt-5" style="width: 100px;" />
      </slot>
      <div class="py-3">
	<h1>
	  <slot name="header">Find Obscure Documents Fast</slot>
	</h1>
      </div>

      <slot name="description">
	<div class="m-auto" style="max-width: 380px;">
	  <p class="mb-0">Conceptual AI Magic!</p>
	  <p class="mb-0">Trinity will be working for you.</p>
	  <p class="mb-5">Her conceptual AI skills enable you to find your files without you having to remember the exact keywords.</p>
	  <p class="mb-0">Then you can browse linked information using Trinity's One-World model.</p>
	</div>
      </slot>

      <slot name="button">
	<b-button size="lg" class="btn-neon-blue my-5" href="https://trinpod.us/pricing?industry=productivity">Get Started</b-button>
      </slot>
    </b-col>
  </b-row>
</b-container>
</b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout02"
}
</script>
